import * as React from 'react';
import { EditModeEnum } from '../interfaces/state';
import { StudyCoughEventType } from '../../../misc/api/apiTypes';

interface EventTypeSelectorProps {
    isVisible: boolean;
    events: Array<StudyCoughEventType>
    eventSelected: StudyCoughEventType;
    isEditMode: EditModeEnum;
    onChange?: (event: StudyCoughEventType) => void;
}

export class EventTypeSelector extends React.Component<EventTypeSelectorProps> {
    constructor(props: EventTypeSelectorProps) {
        super(props);
    }

    onChange = (value) => {
        this.props.onChange(this.props.events.filter(x => x.Id == value)[0]);
    }

    render() {
        if (this.props.events && this.props.events.length > 0 && this.props.isVisible) {
            const selectedVal = this.props.eventSelected ? this.props.eventSelected.Id : this.props.events[0].Id;
            const defaultColour = this.props.eventSelected ? this.props.eventSelected.Colour : '#ffffff';

            return (

                <select id="EventType" style={{ height: 34 + 'px', color: defaultColour }} className="form-control" value={selectedVal} onChange={(e) => { this.onChange(e.target.value); e.target.blur(); }} disabled={this.props.isEditMode !== EditModeEnum.NotEditing}>
                    {this.props.events.map(x => {
                        return (<option style={{ color: x.Colour }} key={x.Id} value={x.Id}>
                            {x.EventName}
                        </option>);
                    })}
                </select>
            );
        } else {
            return null;
        }
    }
}
